import { TbCheck } from "react-icons/tb";

export const PIX_QR_RECEIVE_STEPS = [
  { id: "valor", label: "Valor" },
  { id: "confirmacao", label: "Confirmação" },
  { id: "cobranca", label: "Cobrança" },
];

export const PixQrReceiveStepper = ({ currentStep = 0, compact = false }) => (
  <nav
    aria-label="Etapas da cobrança Pix"
    className={`pix-qr-receive-stepper w-full ${compact ? "mb-3" : "mb-5"}`}
  >
    <ol className="flex w-full items-center">
      {PIX_QR_RECEIVE_STEPS.map((step, index) => {
        const allCompleted = currentStep >= PIX_QR_RECEIVE_STEPS.length;
        const isCompleted = allCompleted || index < currentStep;
        const isActive = !allCompleted && index === currentStep;
        const isLast = index === PIX_QR_RECEIVE_STEPS.length - 1;

        return (
          <li key={step.id} className={`flex items-center ${isLast ? "" : "flex-1"}`}>
            <div
              className={`flex flex-col items-center gap-1 ${
                compact ? "min-w-[2rem] sm:min-w-[3rem]" : "min-w-[2.25rem] sm:min-w-[3.5rem]"
              }`}
            >
              <div
                className={`pix-qr-receive-stepper__node flex items-center justify-center rounded-full font-bold transition ${
                  compact ? "h-8 w-8 text-[11px] sm:h-6 sm:w-6 sm:text-[10px]" : "h-9 w-9 text-xs sm:h-7 sm:w-7 sm:text-[11px]"
                } ${
                  isCompleted
                    ? "pix-qr-receive-stepper__node--completed bg-[#e7a73f] text-white"
                    : isActive
                      ? "pix-qr-receive-stepper__node--active border-2 border-[#e7a73f] bg-white text-[#a66f1d]"
                      : "pix-qr-receive-stepper__node--inactive border border-gray-200 bg-white text-gray-400"
                }`}
              >
                {isCompleted ? <TbCheck className="h-4 w-4 sm:h-3.5 sm:w-3.5" /> : index + 1}
              </div>
              <span
                className={`pix-qr-receive-stepper__label hidden text-center text-[10px] font-semibold sm:block ${
                  isActive || isCompleted
                    ? "pix-qr-receive-stepper__label--active text-brand-dark"
                    : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`pix-qr-receive-stepper__connector mx-1 h-0.5 min-w-[0.5rem] flex-1 rounded-full sm:mx-1.5 ${
                  isCompleted
                    ? "pix-qr-receive-stepper__connector--completed bg-[#e7a73f]"
                    : "pix-qr-receive-stepper__connector--inactive bg-gray-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
